/* eslint-disable */
import styles from './index.module.scss'
import text from './text.json'
import React, { useState, useLayoutEffect, useEffect, useContext } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import Helper from '../../../utils/Helper'
import './styles.css'
import { Navigation, Mousewheel } from 'swiper'
import { ServiceCard } from '../../core/cards'
import { PageContext } from '../../../context/PageContextProvider'
import ServicesAPI from '../../../api/services'
import Loading from '../loading'

const Services = ({ short = false, id = 1 }) => {
  const { language } = useContext(PageContext)
  const [services, setServices] = useState([])
  const [load, setLoad] = useState(false)
  useEffect(() => {
    (async () => {

    const { data } = await ServicesAPI.getAll()
    await setServices(data)
    await setLoad(true)
  
    })();
  }, [])
  const [current, setCurrent] = useState(id)
  const [bool, setBool] = useState(true)
  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth < 768) {
        setBool(false)
        return
      }
      setBool(true)
    }
    window.addEventListener('resize', updateSize)
    updateSize()
  }, [])
  return load ? (
    <section className={styles.container}>
      <div className={styles.header}>
        <span>{text.ours[language] || text.ours.TR || text.ours.AZ}</span>
        <h2>{text.service[language] || text.service.TR || text.service.AZ}</h2>
      </div>
      <div className={styles['swiper-container']}>
        <Swiper
          slidesPerView={'auto'}
          spaceBetween={16}
          breakpoints={{
            768: {
              spaceBetween: 24,
            },
            1200: {
              spaceBetween: 32,
            },
          }}
          slidesOffsetAfter={64}
          navigation={bool}
          modules={[Navigation, Mousewheel]}
          mousewheel={{ forceToAxis: true, releaseOnEdges: true, sensitivity: 1 }}
          className="swiper-services"
        >
          {services.map((item, i) => (
            <SwiperSlide key={i + 1}>
              <ServiceCard
                active={current == i + 1}
                click={() => {
                  setCurrent(i + 1)
                }}
                name={item.service_name?.[language] || ''}
                link={`/services/${i + 1}`}
              />
            </SwiperSlide>
          ))}
          <SwiperSlide className="swiper-services-spacer" />
        </Swiper>
      </div>
      <div className={styles.infoWrapper}>
        <div className={styles.info}>
          <span>{text.details[language] || text.details.TR || text.details.AZ}</span>
          <h2>{services[current - 1]?.service_name?.[language] || services[current - 1]?.service_name?.AZ || ''}</h2>
          <p
            dangerouslySetInnerHTML={{
              __html: (() => {
                const activeService = services[current - 1]
                if (!activeService) return ''
                let d = activeService.description_az || ''
                if (language === 'AZ') d = activeService.description_az
                else if (language === 'TR') d = activeService.description_tr || activeService.description_az
                else if (language === 'ENG') d = activeService.description_eng || activeService.description_az
                else d = activeService.description_ru || activeService.description_az
                d = d || ''
                return short ? Helper.textLengthChecker(d, 420) : d
              })()
            }}
          />
        </div>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default Services
